export default {
      id: "zoom-out-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#zoom-out",
      toString: function () {
        return this.url;
      }
    }